import Vue from 'vue';

const truncateText = (text, maxLength) => {
  if (!text || text.length <= maxLength) return text;
  return text.substr(0, maxLength - 3) + '...';
};

Vue.filter('ellipsis', truncateText);